module.exports = __webpack_public_path__ + "img/horizontal_7_6_5012.056bc708.png";